/**
 * Hook to scroll to anchor after a given delay.
 * @param {number} delay - Delay in milliseconds. Defaults to 500ms.
 */
export default function useScrollToAnchor(delay = 500) {
  // get anchor from url
  const anchor = globalThis?.location?.hash
  // scroll to anchor after 500ms if it exists
  if (anchor) {
    setTimeout(() => {
      const element = document.querySelector(anchor)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }, delay)
  }
}
